_BannerFlowApp.directive("helpIcon", function () {
    return {
        priority: 0,
        restrict: "E",
        replace: false,
        scope: {
            text: "@text",
            container: "@container",
            trigger: "@trigger"
        },
        link: function (scope, element, attrs) {
            $("i", element).popover({
                trigger: scope.trigger ? scope.trigger : "focus",
                container: scope.container ? element.closest(scope.container) : element.parent(),
                placement: attrs.placement ? attrs.placement : "top",
                animation: false
            });

            if (scope.trigger === "manual") {
                $("i", element).on("click", function (openEvent) {
                    $("i.help-icon").popover("hide");

                    openEvent.stopPropagation();
                    openEvent.preventDefault();

                    var i = this;
                    $(i).popover("show");

                    $(document).click(function (closeEvent) {
                        if ($(closeEvent.target).parents(".popover").length === 0) {
                            $(i).popover("hide");
                            $(document).off("click");
                        }
                    });
                });
            }

            scope.$on("$destroy", function () {
                $("i", element).popover("destroy");
                $("i", element).off("click");
            });
        },
        template:
            "<i tabindex='0' style='width: 15px' class='help-icon fa fa-question-circle' data-container='body' data-toggle='popover' data-placement='{{ placement }}' data-html='true' data-delay='200' data-content='{{ text }}'></i>"
    };
});

_BannerFlowApp.directive(
    "bfPopover",
    function ($timeout, $rootScope, $state, $stateParams, $location, $q) {
        return {
            priority: 0,
            restrict: "A",
            replace: false,
            link: function (scope, element, attrs) {
                $(element).popover({
                    trigger: "manual",
                    container: "body",
                    placement: "bottom",
                    html: "true",
                    content: attrs["bfPopover"]
                });

                $(element).click(function (e) {
                    var i = this;
                    $(i).popover("show");

                    $timeout(function () {
                        $(document).one("click", function () {
                            $(i).popover("hide");
                        });
                    }, 100);
                });
            }
        };
    }
);
